<template>
  <header class="ghead">
    <div class="ghead-inner">
      <div class="btn-box">
        <a ontouchstart="" v-if="isMobile && goBack" class="backbtn" @click="$router.go(-1)"><i class="fas fa-arrow-left fa-2x"></i></a>
      </div>
      <router-link to="/" class="sttl"><img src="//cdn.sportsstyle.net/img/static/title.png" width="120px" height="36px" alt="sportsstyleのロゴ"></router-link>
      <transition name="head-state">
        <form class="gsrch" action="/search/?" v-if="headState === 'search'">
          <input ref="gsrchinput" class="gsrch-txt" type="text" name="key" placeholder="ブランド名や商品名で探す" :value="getSearchWord" aria-label="serach form">
          <div class="focus-blur"></div>
          <button class="gsrch-btn" type="submit" aria-label="search button"><i class="fas fa-search"></i></button>
        </form>
        <p class="head-state-title" v-if="headState === 'title'"> {{getHeadTitle}}</p>
      </transition>
      <nav class="gnav">
        <ul class="gnav-list">
          <li class="pc-none">
            <router-link to="/" class="gn-link"><span class="gn-icon"><i class="fas fa-home fa-2x"></i></span><span class="gn-icon-txt">ホーム</span></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Category'}" class="gn-link"><span class="gn-icon"><i class="fas fa-list fa-2x"></i></span><span class="gn-icon-txt">カテゴリ</span></router-link>
          </li>
          <li class="pc-none">
            <a class="gn-link" href="#" @click.prevent="goSearch"><span class="gn-icon"><i class="fas fa-search fa-2x"></i></span><span class="gn-icon-txt">検索</span></a>
          </li>
          <li>
            <router-link :to="{ name: 'Viewed'}" class="gn-link"><span class="gn-icon"><i class="fas fa-eye fa-2x"></i></span><span class="gn-icon-txt">閲覧商品</span></router-link>
          </li>
          <li class="pc-none">
            <a class="gn-link" href="#" v-scroll-to="'#app'"><span class="gn-icon"><i class="fas fa-arrow-up fa-2x"></i></span><span class="gn-icon-txt">上へ戻る</span></a>
          </li>
        </ul>
      </nav>
      <div class="btn-box">
        <a ontouchstart="" v-if="isMobile" class="backbtn" @click="webshare"><i class="fas fa-share-alt fa-2x"></i></a>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import isMobile from 'ismobilejs'

export default {
  props: ['headState'],
  data() {
    return {
      isMobile: isMobile.phone,
      position : 0,
    }
  },
  computed: {
    ...mapGetters([
      'getHeadTitle',
      'getSearchWord'
    ])
  },
  mounted: function () {
    document.onscroll = (e) => {
      this.position = document.documentElement.scrollTop || document.body.scrollTop;
    }
    if(window.history.length > 1){
      this.backBtn = true
    }
  },
  methods: {
    goBack () {
      return window.history.length > 1
        ? ture
        : false
    },
    goSearch: function()
    {
      this.$store.commit('chageHeadState', 'search')
      this.$nextTick(() => this.$refs['gsrchinput'].focus())
    },
    webshare: function(){
      if (navigator.share) {
        navigator.share({
          url: window.location.href,
          title: document.title,
          text: document.title
        })
      } else {
      }
    }
  }
}
</script>

<style scoped>
.ghead{
  background-color: #98c73d;
  top: 0;
  z-index: 9998;
  position: sticky;
  width: 100%;
}
.ghead-inner{
  max-width: 980px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.head-state-title{
  color: #FFF;
  white-space: nowrap;
  overflow: hidden;
  font-size: .8rem;
  padding: 0px 8px;
  width: 100%;
  margin: 0;
}
.sttl {
  width: 120px;
  padding: 0 6px;
}
.gsrch{
  width: 100%;
  max-width: 640px;
  padding: 6px 8px;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  margin: 0 16px;
}
.gsrch-txt{
  background-color: #FFF;
  padding: 0 30px 0 6px;
  border: none;
  border-radius: 4px;
  outline: none;
  background: none;
  background-color: #FFF;
  display: inline-block;
  height: 26px;
  width: 100%;
  color: #999;

}

.gsrch-txt:focus{
  color: #333;
}

.gsrch-btn{
  position: absolute;
  right: 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  outline: none;
  background: transparent;
  color: #AAA;
}
.gnav{
  min-width: 170px;

}
.gnav-list{
  display: flex;
  list-style: none;
  justify-content: start;
  padding: 6px 0 2px;
  margin: 0 -12px;
}
.gn-link{
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #FFF;
  padding: 0 12px;
  width: 100%;
}
.gn-icon{
  display: block;
  font-size: .65rem;
  padding-top: 3px;
}
.gn-icon-txt{
  display: block;
  font-size: .6rem;
  padding: 2px 0 0 6px;
}

.btn-box{
  display: none;
  width: 40px;
  height: 40px;
  padding: 4px;
}
.backbtn{
  display: block;
  width: 32px;
  height: 32px;
  color: #FFF;
  padding: 4px;
  transition: all .3s ease;
}
.backbtn:active{
  background-color: rgba(255,255,255, .6);
  border-radius: 6px;
}

@media all and (max-width: 767px) {
  .gnav{
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999;
    background-color: #FFF;
    border-top: 1px solid #DDD;
  }
  .gn-link{
    color: #025939;
    display: block;
    padding: 0;
  }
  .sttl{
    display: none;
  }
  .btn-box{
    display: block;
  }
  .gsrch{
    margin: 0 6px;
  }
  .gnav-list{
    padding: 4px 6px;
    justify-content: space-evenly;
  }
  .gnav-list li{
    width: 25%;
  }
  .gsrch-txt:focus + .focus-blur{
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,.5);
    position: absolute;
    left: -46px;
    top: 39px;
  }
}


.head-state-enter-active, .head-state-leave-active {
  transition: all .3s ease;
}

.head-state-enter, .head-state-leave-active {
  opacity: 0;
}
.head-state-enter {
  transform: translateX(31px);
}
.head-state-leave-active {
  transform: translateX(-31px);
}
</style>
